module.exports = "https://coursera_assets.s3.amazonaws.com/images/747e14ad140eb3a482a04ffd88001198.png";